import { APIS, URLS } from '@/shared/config/urls';
import type { PageResponse } from '@/shared/types/abstract-api-response';
import { request } from '@/shared/utils/request';
import type { ProductDetail, ProductListParams, ProductSummary } from '../types/product.types';

/** Bundles first (they ignore `q`), then books. */
export const fetchProducts = async ({
  page,
  size,
  q,
}: ProductListParams): Promise<PageResponse<ProductSummary>> => {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  if (q) params.set('q', q);
  return await request.get(`${URLS.BACK_DSH}${APIS.products(params.toString())}`);
};

/** 404 when the product does not exist, is hidden or is sold out. */
export const fetchProduct = async (slug: string): Promise<ProductDetail> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.productDetail(slug)}`);
};
